if (!customElements.get("s-header")) {
  customElements.define(
    "s-header",
    class SectioHeader extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.cartModalBtn = this.querySelector(".js-header__cart-button");
        this.mobileMenuButton = this.querySelector(".js-header__burger-button");
        this.searchButton = this.querySelector(".js-header__search-button");

        this.inputSearch = this.querySelector(".js-header__search-input");

        if (this.inputSearch) {
          const debounceApiDataRequest = debounce(() => {
            this.searchInputHandler();
          }, 300);

          this.inputSearch.addEventListener(
            "input",
            debounceApiDataRequest.bind(this)
          );
        }

        this.cartModalBtn.addEventListener("click", this.cartModalBtnHandler);
        this.mobileMenuButton.addEventListener("click", this.mobileMenuHandler);
        this.searchButton.addEventListener("click", this.searchButtonHandler)
      }

      disconnectedCallback() {
        this.cartModalBtn.removeEventListener("click", this.cartModalBtnHandler);
        this.mobileMenuButton.removeEventListener("click", this.mobileMenuHandler)
        this.searchButton.removeEventListener("click", this.searchButtonHandler)
      }

      cartModalBtnHandler = (event) => {
        event.preventDefault();

        window.PubSub.publish("cart-modal:open")
      }

      searchInputHandler = () => {
        let query = this.inputSearch.value;

        window.PubSub.publish("search-modal:open", query)
      }

      searchButtonHandler = () => {
        if (this.searchButton.classList.contains("is-open")) {
          this.searchButton.classList.remove("is-open");
          window.PubSub.publish("search-modal:close")
        } else {
          this.searchButton.classList.add("is-open");
          window.PubSub.publish("search-modal:open", "")
        }
      }

      mobileMenuHandler = (event) => {
        event.preventDefault();

        window.PubSub.publish("mobile-menu", this.mobileMenuButton.classList.contains("is-active"))

        if(this.mobileMenuButton.classList.contains("is-active")) {
          this.mobileMenuButton.classList.remove("is-active")
        } else {
          this.mobileMenuButton.classList.add("is-active")
        }
      }
    }
  );
}
